import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
  Divider
} from "@mui/material";
import { 
  Circle, 
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import AssessmentQuestions from "../Components/Dialogs/AssessmentQuestions";
import ActiveSessionsTable from "../Components/Table/ActiveSessionTable";
import useGetAssessments from "../Hooks/useGetAssessments";

const AssessmentSessionLayout = () => {
    const [assessmentId, setAssessmentsId] = useState(null);
    const [openAssessment, setOpenAssessment] = useState(false);
    
    const [openGrader, setOpenGrader] = useState(false);
    const [studentId, setStudentId] = useState(null);
    const [sessionToken, setSessionToken] = useState(null);
    const [semesterId, setSemesterId] = useState(null);

    const dispatch = useDispatch();
    const programs = useSelector((state) => state.role.tutor_programs);
    const { assessments, sessions, fetchAssessmentSessions, fetchAssessments} = useGetAssessments();

    useEffect(() => {
        fetchAssessments();
        fetchAssessmentSessions();
    }, [dispatch]);
    
    const handleAssessmentClose = () => {
      setAssessmentsId(null);
      setOpenAssessment(false);
      setOpenGrader(false);
      setStudentId(null);
      setSessionToken(null);
      setSemesterId(null);
      fetchAssessmentSessions();
    }

    const handleGrader = (session) => {
      const { semester_id, student_id, assessment_id, session_token } = session;
      setStudentId(student_id);
      setAssessmentsId(assessment_id);
      setOpenGrader(true);
      setSessionToken(session_token);
      setSemesterId(semester_id)

    }
  return (
    <Box sx={{ flexGrow: 1, p: 1 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ 
            fontWeight: 600, 
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <Circle sx={{ fontSize: 10, color: 'primary.main' }} /> 
            Assessments sessions
        </Typography>
        <ActiveSessionsTable
          sessions={sessions}
          onView={(session) => handleGrader(session)}
        />
      </Box>
      <Divider sx={{mb: 1}} />     

      <AssessmentQuestions 
        proctor={openGrader} 
        assessmentId={assessmentId}
        studentId={studentId}
        semesterId={semesterId}
        open={openAssessment || openGrader} 
        onClose={handleAssessmentClose} 
        grader={openGrader}
        sessionToken={sessionToken}
      />
    </Box>
  );
};

export default AssessmentSessionLayout;